﻿import { format, differenceInDays } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Crown } from "lucide-react";

export function SubscriptionCard({
  subscription,
  setIsUpgradeModalOpen,
}: {
  subscription: any;
  setIsUpgradeModalOpen: (val: boolean) => void;
}) {
  if (!subscription) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500/10 to-amber-700/5 border border-amber-500/20 p-6 rounded-2xl shadow-lg flex flex-col md:flex-row justify-between items-center gap-4">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center text-amber-500">
          <Crown size={24} />
        </div>
        <div>
          <h2 className="text-xl font-bold text-amber-400 flex items-center gap-2">
            Plano {subscription.system_plans?.name || "Assinante"}
          </h2>
          <p className="text-sm text-slate-400 mt-0.5">
            Renovação automática em:{" "}
            <strong className="text-slate-300">
              {subscription.current_period_end
                ? format(
                    new Date(subscription.current_period_end),
                    "dd 'de' MMMM",
                    {
                      locale: ptBR,
                    },
                  )
                : "Indefinido"}
            </strong>
          </p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-end md:items-center gap-4 md:gap-6 mt-4 md:mt-0">
        <div className="flex flex-col items-end">
          <span
            className={`text-sm font-bold px-3 py-1 rounded-full ${
              subscription.current_period_end &&
              new Date(subscription.current_period_end) < new Date()
                ? "bg-red-500/20 text-red-400 border border-red-500/30"
                : subscription.status === "TRIALING"
                  ? "bg-blue-500/20 text-blue-400 border border-blue-500/30"
                  : "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30"
            }`}
          >
            {subscription.current_period_end &&
            new Date(subscription.current_period_end) < new Date()
              ? "Assinatura Vencida"
              : subscription.status === "TRIALING"
                ? "Período de Testes"
                : "Assinatura Ativa"}
          </span>
          {subscription.current_period_end &&
            new Date(subscription.current_period_end) >= new Date() && (
              <span className="text-xs text-slate-500 mt-2 font-mono">
                {differenceInDays(
                  new Date(subscription.current_period_end),
                  new Date(),
                )}{" "}
                dias restantes
              </span>
            )}
        </div>

        {(subscription.status === "TRIALING" ||
          subscription.status === "PAST_DUE" ||
          (subscription.current_period_end &&
            new Date(subscription.current_period_end) < new Date())) && (
          <button
            onClick={() => setIsUpgradeModalOpen(true)}
            className="px-6 py-2 bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-slate-950 font-bold rounded-lg shadow-md transition-all active:scale-95 whitespace-nowrap"
          >
            Ver Planos
          </button>
        )}
      </div>
    </div>
  );
}
